<div class="close-icon" mat-button (click)="dialogRef.close()"></div>
<div class="training-component" style="margin-top: 50px;">
  <div *ngIf="answers && users && quiz" style="width: 100%;">
    <p-table [value]="answers"
             [paginator]="false"
             [style]="{'margin-top':'10px'}"
             #table
             [columns]="columns"
    >
      <ng-template pTemplate="caption">
        <div style="display: flex; flex-direction: row; justify-content: flex-end; align-items: center">

          <button type="button"
                  pButton
                  class="risksponge-button"
                  icon="pi pi-file-excel"
                  iconPos="left"
                  label="Export"
                  (click)="exportAnswers()"
                  style="float:right">
          </button>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr style="white-space: nowrap; font-weight: bold;">
          <th rowspan="2">User Name</th>
          <th rowspan="2">Date Submitted</th>
          <th *ngFor="let step of quiz.quizData.steps; let stepNumber = index" [colSpan]="step.items.length">{{stepNumber + 1}}</th>
        </tr>
        <tr>
          <ng-container *ngFor="let step of quiz.quizData.steps">
            <th *ngFor="let question of step.items">
              {{question.name}}
            </th>
          </ng-container>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr>
          <td>{{getFullName(item.userId)}}</td>
          <td>{{item.date | date: 'shortDate'}} {{item.date | date: 'shortTime'}}</td>
          <ng-container *ngFor="let step of quiz.quizData.steps; let stepNumber = index">
            <td *ngFor="let question of step.items; let questionNumber = index">
              <ng-container
                *ngIf="question.type == 'textQuestion'">{{item.results['r' + stepNumber + '_' + questionNumber]}}</ng-container>
              <ng-container
                *ngIf="question.type == 'question'">
                <ng-container
                  *ngFor="let answer of question.answers;let i = index"><ng-container *ngIf="(item.results['r' + stepNumber + '_' + questionNumber] || []).indexOf(i) >= 0">{{answer.name}} </ng-container>
                </ng-container>
                <ng-container *ngIf="question.hasPleaseExplain">({{item.results['r' + stepNumber + '_' + questionNumber + '_pleaseexplain']}})</ng-container>
              </ng-container>
              <ng-container
                *ngIf="question.type == 'attachment'">
                <ng-container
                  *ngFor="let answer of item.results['r' + stepNumber + '_' + questionNumber];let i = index">
                  <a href="{{api + '/api/attachments/file?name=' + encodeURIComponent(answer.internalName) + '&path=Surveys/' + trainingId + '/' + '&token=' + token}}"
                     rel="noopener" target="_blank" style="margin-right: 10px;">{{answer.name}}</a>
                </ng-container>
              </ng-container>
            </td>
          </ng-container>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
